import React from 'react'
import NoAvatar from '../images/NoAvatar.png'
import './Avatar.css'

export default function Avatar(props: any) {
  let avatarimage: string = props.src
  if (avatarimage == '') avatarimage = NoAvatar
  return (
    <div className="avatar-area">
      <img className="avatar-area-image" src={avatarimage}></img>
    </div>
  )
}
